import { defineComponent as _defineComponent } from 'vue'
import {ref, onMounted, onUnmounted} from 'vue'
import ButtonCommon from './buttons/ButtonCommon.vue'
import ProgressBar from './ProgressBar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadFile',
  props: {
    uploadText: null,
    uploadTextLine2: null,
    uploadButtonLabel: null,
    acceptType: null,
    fileSizeUnits: null,
    wrongTypeErrorMessage: null,
    uploadFileErrorMessage: null,
    uploadedFileUrl: null,
    uploadedFile: null
  },
  emits: ["upload-done", "removed-file", "upload-init"],
  setup(__props: any, { emit }: { emit: ({
  (e: "upload-done", object?: {
    formData: FormData,
    fileUrl: string,
    addedFile: File
  }): void;
  (e: "removed-file"): void;
  (e: "upload-init"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  uploadText: string;
  uploadTextLine2: string;
  uploadButtonLabel: string;
  acceptType: string;
  fileSizeUnits: string[];
  wrongTypeErrorMessage: string;
  uploadFileErrorMessage: string;
  uploadedFileUrl?: string;
  uploadedFile?: File;
};




const file = ref<File | null>(null)
const fileSize = ref('')
const fileUrl = ref('')
const wrongTypeError = ref(false)
const uploadFileError = ref(false)
const events = ['dragenter', 'dragover', 'dragleave', 'drop']
const errorMessage = ref('')
const uploadProgress = ref(0)

function onInputChange(e: Event) {
  const target = e && e.target as HTMLInputElement
  const file = target && target.files && target.files.length ? target.files[0] : undefined
  if (file) {
    getFileInfo(file)
  }
}

function onDrop(e: DragEvent) {
  const file = e && e.dataTransfer && e.dataTransfer.files ? e.dataTransfer.files[0] : undefined

  if (file) {
    getFileInfo(file)
  }
}

function preventDefaults(e: { preventDefault: () => void; }) {
  e.preventDefault()
}

function clearFileInfo(errorMessageStr?: string) {
  file.value = null;
  uploadFileError.value = false;
  wrongTypeError.value = false
  errorMessage.value = errorMessageStr ? errorMessageStr : ''
  uploadProgress.value = 0
  fileSize.value = ''
  fileUrl.value = ''
  emit('removed-file')
}

function getFileSize(size: number){
  const fileSizeUnits = props.fileSizeUnits;
  const k = 1000;

  if (size == 0) {
    return `0 ${fileSizeUnits}`;
  }

  let i = Math.floor(Math.log(size) / Math.log(k));

  i = i >= fileSizeUnits.length ? fileSizeUnits.length - 1 : i;

  return parseFloat((size / Math.pow(k, i)).toFixed(1)) + ' ' + fileSizeUnits[i];
}

function getFileInfo(addedFile: File) {
  emit('upload-init')
  clearFileInfo();

  if (!addedFile) {
    return
  }

  if (!addedFile.type || !props.acceptType.includes(addedFile.type)) {
    wrongTypeError.value = true
    errorMessage.value = props.wrongTypeErrorMessage
    return
  }

  file.value = addedFile
  fileSize.value = getFileSize(addedFile.size)

  const reader = new FileReader();

  reader.onload = async () => {
    const data = reader.result;

    uploadProgress.value = 60

    if (typeof data === 'string') {
      const formData = new FormData();
      formData.append('data', addedFile)

      uploadProgress.value = 100
      fileUrl.value = URL.createObjectURL(addedFile)
      emit('upload-done', {
        formData,
        fileUrl: fileUrl.value,
        addedFile
      })
    }
  };

  reader.onerror = () => {
    clearFileInfo();
    errorMessage.value = props.uploadFileErrorMessage
    uploadFileError.value = true;
  };

  reader.readAsBinaryString(addedFile);
}

onMounted(() => {
  events.forEach((eventName) => {
    document.body.addEventListener(eventName, preventDefaults)
  })
  if (props.uploadedFileUrl && props.uploadedFile) {
    fileUrl.value = props.uploadedFileUrl;
    file.value = props.uploadedFile;
    uploadProgress.value = 100
  }
})

onUnmounted(() => {
  events.forEach((eventName) => {
    document.body.removeEventListener(eventName, preventDefaults)
  })
})

return { __sfc: true,props, emit, file, fileSize, fileUrl, wrongTypeError, uploadFileError, events, errorMessage, uploadProgress, onInputChange, onDrop, preventDefaults, clearFileInfo, getFileSize, getFileInfo, ButtonCommon, ProgressBar }
}

})